import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EmployeeFormFactory } from '@internal-factories/forms/employee-form.factory';
import { IEmployee } from '@internal-models/employee.model';
import { NavigationType } from '@shared-libs/enums';
import { formIsValid } from '@shared-libs/helpers';
import { IFormGroup } from '@shared-libs/interfaces';
import { BasePage } from '@shared-pages/base.page';
import { AuthenticationService } from '@shared-services/authentication.service';
import { NavigationService } from '@shared-services/navigation.service';
import { PublicUserProvider } from '../../../../login/providers/api/user.provider';

@Component({
	selector: 'register-page',
	templateUrl: 'register.page.html',
	styleUrls: ['register.page.scss'],
})
export class RegisterPage extends BasePage {
	public readonly employeeForm: IFormGroup<IEmployee>;
	public tenantId: string;
	public isRegistered: boolean = false;

	constructor(
		public readonly authenticationService: AuthenticationService,
		private readonly loginProvider: PublicUserProvider,
		private readonly route: ActivatedRoute,
		private readonly navigationService: NavigationService
	) {
		super();
		this.employeeForm = EmployeeFormFactory.createForCreate();
		this.route.params.subscribe((params) => {
			this.tenantId = params.id;
		});
	}

	public async register(): Promise<void> {
		if (formIsValid(this.employeeForm, RegisterPage)) {
			await this.loginProvider.register({ ...this.employeeForm.value, TenantId: this.tenantId });
			this.isRegistered = true;
		}
	}

	public navigateToLogin(): void {
		void this.navigationService.navigateTo(NavigationType.page, '/login').catch();
	}
}
